// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__xBtPv","backdrop_darkened":"Modal_backdrop_darkened__Lu+V-"};